<template>
	<inertia-head title="Home" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Insurance Information
					</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Please update your informaation for the insurance purpose
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content mt-5">
		<div class="row py-4">
			<div class="col-xl-9 m-auto">
				<div v-if="member.is_eligible==0" class="block block-rounded shadow">
					<div class="block-content block-content-full">
						<h3 class="text-center text-danger m-0">You current <strong>age</strong> is not eligible for the TRC Group Insurance.</h3>
					</div>
				</div>
				<div v-if="member.profile_complete==0 && member.is_eligible==1" class="block block-rounded shadow">
					<div class="block-content block-content-full">
						<div class="form-floating mb-4">
							<input type="text" v-model="form.fname" id="fname" name="fname" class="form-control" placeholder="First Name">
							<label class="form-label">First Name</label>
							<div v-if="form.errors.fname && form.fname==''" class="show-error">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.fname }}
							</div>
						</div>
						<div class="form-floating mb-4">
							<input type="text" v-model="form.mname" id="mname" name="mname" class="form-control" placeholder="Middle Name">
							<label class="form-label">Middle Name</label>
							<div v-if="form.errors.mname && form.mname==''" class="show-error">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.mname }}
							</div>
						</div>
						<div class="form-floating mb-4">
							<input type="text" v-model="form.lname" id="lname" name="lname" class="form-control" placeholder="Last Name">
							<label class="form-label">Last Name</label>
							<div v-if="form.errors.lname && form.lname==''" class="show-error">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.lname }}
							</div>
						</div>
						<div class="form-floating mb-4">
							<input type="text" v-model="form.suffix" id="suffix" name="suffix" class="form-control" placeholder="Suffix">
							<label class="form-label">Suffix</label>
							<div v-if="form.errors.suffix && form.suffix==''" class="show-error">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.suffix }}
							</div>
						</div>
						<div class="form-floating mb-4">
							<select v-model="form.gender" id="gender" name="gender" class="form-control" placeholder="Gender">
								<option value="Male">Male</option>
								<option value="Female">Female</option>
							</select>
							<label class="form-label">gender</label>
							<div v-if="form.errors.gender && form.gender==''" class="show-error">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.gender }}
							</div>
						</div>
						<div class="form-floating mb-4">
							<input type="date" v-model="form.bday" id="bday" name="bday" class="form-control" placeholder="Birth Date"/>
							<label class="form-label">Birth Date</label>
							<div v-if="form.errors.bday && form.bday==''" class="show-error">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.bday }}
							</div>
						</div>
						<div class="form-floating mb-4">
							<vue-tel-input
								id="mobile"
								name="mobile"
								v-model="form.mobile"
								:value="form.mobile"
								@input="onInput"
								@countryChanged="onCountryChange"
								:defaultCountry="form.country_code"
								mode="international"
								class="form-control"
								:input-options="{
									placeholder: 'Enter mobile number',
								}"
							/>
							<label class="form-label">Mobile</label>
							<div v-if="(is_valid_mobile==false || is_valid_mobile==undefined) && form.errors.mobile" class="show-error">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.mobile }}
							</div>
						</div>
						<div class="form-floating mb-4">
							<input type="text" v-model="form.address" id="address" name="address" class="form-control" placeholder="Home Address"/>
							<label class="form-label">Home Address</label>
							<div v-if="form.errors.address && form.address==''" class="show-error">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.address }}
							</div>
						</div>
						<div>
							<div class="form-floating mb-4">
								<select v-model="form.country" id="country" name="country" class="form-select">
									<option v-for="country in countries" :value="country.country">{{country.country}}</option>
								</select>
								<label class="form-label">Country</label>
								<div v-if="form.errors.country && form.country==''" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ form.errors.country }}
								</div>
							</div>
							<div v-if="form.country=='Philippines'">
								<div class="form-floating mb-4">
									<select v-model="form.province" id="province" name="province" class="form-select">
										<option v-for="province in provinces" :value="province.prov_code+'|'+province.prov_desc">{{province.prov_desc}}</option>
									</select>
									<label class="form-label">Province</label>
									<div v-if="form.errors.province && form.province==''" class="show-error">
										<i class="fa fa-exclamation-circle"></i>
										{{ form.errors.province }}
									</div>
								</div>
								<div class="form-floating mb-4">
									<select v-model="form.city" id="city" name="city" class="form-select">
										<option v-for="city in cities[(form.province).split('|')[0]]" :value="city.citymun_desc">{{city.citymun_desc}}</option>
									</select>
									<label class="form-label">City</label>
									<div v-if="form.errors.city && form.city==''" class="show-error">
										<i class="fa fa-exclamation-circle"></i>
										{{ form.errors.city }}
									</div>
								</div>
							</div>

							<div class="form-group my-5">
			                	<h5 style="font-weight: 600">Health Declaration</h5>
			                	<p>I hereby declare that during the past 5 years:</p>
			                	<ol type="a">
			                		<li>
			                			<input type="checkbox" v-model="form.health_declaration.health_choice_a" id="health_choice_a" name="health_choice_a">
			                			I have not consulted any doctor for medical treatment not have I have been confined in a hospital, clinic or similar institutions.
			                		</li>
			                		<li>
			                			<input type="checkbox" v-model="form.health_declaration.health_choice_b" id="health_choice_b" name="health_choice_b">
			                			I have not been advised that I have heart trouble, high blood pressure, cancer, diabetes, epilepsy, tuberculosis, Acquired Immune Deficiency Syndrome (AIDS), AIDS related Complex (ARC), or AIDS related condition.
			                		</li>
			                		<li>
			                			<input type="checkbox" v-model="form.health_declaration.health_choice_c" id="health_choice_c" name="health_choice_c">
			                			I am not aware of any impairment in my health or physical condition.
			                		</li>
			                		<li>
			                			<input type="checkbox" v-model="form.health_declaration.health_choice_d" id="health_choice_d" name="health_choice_d">
				                		I am now in good health.
				                	</li>
			                		
			                		<li v-if="member.gender && member.gender.toLowerCase()=='female'">
			                			Are you currently pregnant?
			                			<span>
				                			<select v-model="form.health_declaration.is_pregnant" id="is_pregnant" name="is_pregnant" style="appearance:auto;">
				                				<option value="No">No</option>
				                				<option value="Yes">Yes</option>
				                			</select>
			                			</span>
			                			<div v-if="form.health_declaration.is_pregnant=='Yes'">
			                				If Yes, How many months?
			                				<input type="text" v-model="form.health_declaration.month_pregnant" id="month_pregnant" name="month_pregnant">
			                			</div>
			                		</li>
			                		
			                	</ol>
			                	<div class="form-group">
			                		<p>No medical or physical examination shall be required although the Company reserves the right to require evidence of insurability.</p>
			                	</div>
			                </div>

			                <div class="form-group">
			                	<p>
			                		<input type="checkbox" v-model="form.health_declaration.is_acknowledge" id="is_acknowledge" name="is_acknowledge">
			                		I HEREBY CERTIFY that the information provided in this form is complete, true and correct to the best of my knowledge.
			                	</p>
			                </div>

						</div>
					</div>
					<div class="block-footer pb-5 text-center">
						<button @click="toggleModal" type="button" class="btn btn-success px-5">
							<span ><i class="fa fa-save me-1"></i>Next Step</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>

	<modal ref="modal">
		<template #title>Confirmation</template>
		<template #body>
			<p>Please double check all the info provided. Your name should match the ID that you'll be submitting in the next steps. We will also send a One-Time-Pin to your mobile number.</p>
		</template>
		<template #footer>
			<button @click="updateInfo" type="button" class="btn btn-alt-success">
				<span v-if="!form.processing">Confirm</span>
				<span v-else>
					<div class="spinner-border spinner-border-sm text-dark" role="status" >
						<span class="sr-only mr-1">Please wait...</span>
					</div>
					<span class="mx-2">Please wait...</span>
				</span>
			</button>
			<button @click="toggleModal" type="button" class="btn btn-alt-danger">
				Cancel
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref, onMounted } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import AuthLayout from '../../../Layouts/AuthLayout'
import { createToaster } from '@meforma/vue-toaster'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	props:{
		flash 				: Object,
		errors 				: Object,
		member 				: Object,
		countries 			: Object,
		provinces 			: Object,
		cities 				: Object,
		api_response		: Object
	},
	layout: AuthLayout,
	setup(props) {

		const is_valid_mobile = ref(false);

		const toast = createToaster();

		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}
		
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
			{
				pageContainer.classList.remove('sidebar-o-xs')
			}
			
			// if(props.flash)
			// {
			// 	toast.show(props.flash.message, { type: "success"});
			// }

		})
		
		const form = useForm({
			fname				: props.member.fname??'',
			mname				: props.member.mname??'',
			lname				: props.member.lname??'',
			suffix 				: props.member.suffix??'',
			gender 				: props.member.gender??'',
			bday				: props.member.bday??'',
			mobile 				: props.member.mobile??'',
			country_code 		: props.member.country_code??'PH',
			country_calling_code: props.member.country_calling_code??'63',
			address				: props.member.address??'',
			country				: props.member.country??'Philippines',
			province			: props.member.province??'',
			city				: props.member.city??'',
			health_declaration : {
				health_choice_a : false,
				health_choice_b : false,
				health_choice_c : false,
				health_choice_d : false,
				is_pregnant		: 'No',
				month_pregnant	: 0,
				is_acknowledge	: false
			}
		});

		const onInput = (number, phoneObject) => {
			if (phoneObject.formatted!="") {
				form.mobile = phoneObject.number
				form.country_calling_code = phoneObject.countryCallingCode
			}else
			{
				form.mobile = "";
			}
			is_valid_mobile.value = phoneObject.valid;

		}

		const onCountryChange = (countryObject) => {
			form.country_code = countryObject.iso2
		}

		const updateInfo = ()=>{
			form.put("insurance/"+props.member.member_uuid,{
				preserveState: true,
				preserveScroll: true,
				only:['errors','flash','api_response','member'],
				onSuccess: ()=>{},
				onError:()=>{
					var fields = ['fname','mname','lname','gender','bday','mobile','address','country','province','city'];
					//Check if error exist and focus the first field.
					for (var i = 0; i < fields.length; i++) {

						var found = false;

						for (const [key, value] of Object.entries(form)) {

							if(fields[i]==key){

								if(form.errors[key]){
									var  el = document.getElementById(key);
									if(key=='mobile'){
										el = document.getElementsByClassName("vti__input")[0];
									}
									
									el.focus();	

									found = true;

									break;
								}
							}
						}

						if(found==true){
							toggleModal();
							break;
						}
					}
				}
			})
		}

		watch(()=>props.api_response,(response)=>{

			if(response!==null)
			{
				if(response.result=="success")
				{
					toast.show("Successfully updated", { type: response.result});
				}else
				{
					toast.show("Failed to update", { type: "error"});
				}
			}
		})

		return{
			is_valid_mobile,
			toast,
			form,
			onInput,
			modal,
			toggleModal,
			updateInfo,
			onCountryChange
		}

	},
}
</script>
